/**
 * Extracted from sections/ns-media-tabs.liquid (inline <script> at line 202).
 * Config bridge: window.__nsMediaTabsSections, keyed by section id. The inline block
 * only needed Liquid for the section id, so the id is handed over as data
 * and the logic now runs from a cacheable, deferred asset instead of being
 * parsed and compiled during the HTML parse (INP work on the PDP).
 * Boots once per section id so multiple instances each initialise.
 */

(function () {
  var cfg = window.__nsMediaTabsSections = window.__nsMediaTabsSections || {};
  function boot(nsSectionId, nsSettings) {
        (function () {
        // Tiny enhancement: the first panel renders without JS; the rail just
        // swaps which panel is hidden.
        
          var root = document.getElementById(`shopify-section-${nsSectionId}`);
          if (!root) return;
          var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-gtb-tab]'));
          var panels = Array.prototype.slice.call(root.querySelectorAll('[data-gtb-panel]'));
          tabs.forEach(function (tab, i) {
            tab.addEventListener('click', function () {
              tabs.forEach(function (t, j) { t.setAttribute('aria-selected', String(i === j)); });
              panels.forEach(function (p, j) { p.hidden = i !== j; });
              // A tab clicked while partially cut off at the rail edge scrolls
              // itself fully into view (nearest keeps the page from jumping).
              tab.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' });
            });
          });

          var rail = root.querySelector('.ns-gtb__rail');
          if (rail) {
            var syncFade = function () {
              var overflowing = rail.scrollLeft < rail.scrollWidth - rail.clientWidth - 1;
              if (overflowing) { rail.setAttribute('data-overflow-right', ''); }
              else { rail.removeAttribute('data-overflow-right'); }
            };
            rail.addEventListener('scroll', syncFade, { passive: true });
            window.addEventListener('resize', syncFade);
            syncFade();
          }
        })();
    
  }
  Object.keys(cfg).forEach(function (id) {
    var s = cfg[id];
    if (!s || s.__booted) return;
    s.__booted = true;
    boot(id, s);
  });
})();
